'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendHeartbeat = exports.sendOfflineNotice = exports.sendOnlineNotice = undefined;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sendOnlineNotice = exports.sendOnlineNotice = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_ONLINE_PRESENCE_NOTICE);

var sendOfflineNotice = exports.sendOfflineNotice = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_OFFLINE_PRESENCE_NOTICE);

var sendHeartbeat = exports.sendHeartbeat = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_PRESENCE_HEARTBEAT);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/PresenceActions.js
// module id = 474
// module chunks = 0